function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Image from './Image';
export const Avatar = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Image, _extends({
  ref: ref,
  sx: {
    cursor: props.onClick ? 'pointer' : 'default',
    size: 50,
    borderRadius: 'circle',
    border: 'default',
    '&:hover, &:focus': {
      border: props.onClick ? 'link' : 'default'
    }
  }
}, props)));
Avatar.displayName = 'Avatar';
export default Avatar;